export default __webpack_public_path__ + "static/media/golo-table-red.836dc375.webp";